import { clsx } from 'clsx'

export const Section = ({
  title,
  subtitle,
  children,
  className,
}: {
  title: React.ReactNode
  subtitle?: React.ReactNode
  children?: React.ReactNode
  className?: string
}) => {
  return (
    <div className={clsx('space-y-4', className)}>
      <div className="space-y-1">
        {title && <Title size="lg">{title}</Title>}
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </div>
      <div>{children}</div>
    </div>
  )
}

export const SectionSeparator = ({ visitor }: { visitor?: boolean }) => {
  return (
    <hr
      className={clsx(
        visitor ? 'my-4 border-transparent' : 'my-8 border-dark-border-solid'
      )}
    />
  )
}

const Title = ({
  children,
  className,
  size = 'md',
}: {
  children?: React.ReactNode
  className?: string
  size?: 'md' | 'lg'
}) => {
  return (
    <h2 className={clsx(className, 'font-medium', size === 'lg' && 'text-lg')}>
      {children}
    </h2>
  )
}

export const Subtitle = ({
  children,
  className,
}: {
  children?: React.ReactNode
  className?: string
}) => {
  return (
    <div
      className={clsx(
        className,
        'text-sm leading-[19px] text-dark-muted text-pretty'
      )}
    >
      {children}
    </div>
  )
}
